import { render, staticRenderFns } from "./intelligentBodyManage.vue?vue&type=template&id=b6cb6d12&scoped=true"
import script from "./intelligentBodyManage.vue?vue&type=script&lang=js"
export * from "./intelligentBodyManage.vue?vue&type=script&lang=js"
import style0 from "./intelligentBodyManage.vue?vue&type=style&index=0&id=b6cb6d12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cb6d12",
  null
  
)

export default component.exports